import React from "react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
};
export function SectionCta({
  label
}: SectionCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-65" data-mp="5pu55pjsxyp">
      <CtaButton label={label} data-id="element-66" data-mp="3ie8crotjiayf" />
    </div>;
}